// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5350) return "static/chunks/5350-54950478e0c3a984.js";
	if (chunkId === 8264) return "static/chunks/8264-2b18ec22da6cfa44.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7701 ? "2164e884" : chunkId) + "." + {"68":"268ef213216007b2","592":"5c8db649b7ea24bc","5922":"7af035f40ac4768f","7701":"4c0d147bbaef60fc","8723":"c009444300564ba6","9673":"fdf37a376fae69e7"}[chunkId] + ".js";
};